import React from 'react';
import {
	EmailIcon,
	EmailShareButton,
	FacebookIcon,
	FacebookShareButton,
	FacebookShareCount,
	LinkedinIcon,
	LinkedinShareButton,
	RedditIcon,
	RedditShareButton,
	RedditShareCount,
	TelegramIcon,
	TelegramShareButton,
	TumblrIcon,
	TumblrShareButton,
	TumblrShareCount,
	TwitterShareButton,
	WhatsappIcon,
	WhatsappShareButton,
	XIcon,
} from 'react-share';

const ShareInSocialNetworks = ({ url, title = '', hashtags = ['#stocks'] }) => {
	let withoutHashTag = hashtags.map((element) => element.replace('#', ''));

	return (
		<div className={'flex flex-col justify-center'}>
			<h3 className={'text-xl font-bold md:text-4xl md:leading-tight dark:text-white mb-2 block text-center'}>Share on Social Networks:</h3>
			<div className="flex align-middle justify-center gap-x-2">
				<div className={'flex flex-col'}>
					<FacebookShareButton url={url} hashtag={hashtags[0]} aria-label={'Share on Facebook'}>
						<FacebookIcon size={32} round />
					</FacebookShareButton>
					<div className={'text-center'}>
						<FacebookShareCount url={url}>{(count) => count}</FacebookShareCount>
					</div>
				</div>
				<div className={'flex flex-col'}>
					<TwitterShareButton url={url} title={title} hashtags={withoutHashTag} aria-label={'Share on Twitter'}>
						<XIcon size={32} round />
					</TwitterShareButton>
				</div>

				<div className={'flex flex-col'}>
					<LinkedinShareButton url={url} source={url} title={title} aria-label={'Share on Linkedin'}>
						<LinkedinIcon size={32} round />
					</LinkedinShareButton>
				</div>

				<div className={'flex flex-col'}>
					<TelegramShareButton url={url} title={title} aria-label={'Share on Telegram'}>
						<TelegramIcon size={32} round />
					</TelegramShareButton>
				</div>
				<div className={'flex flex-col'}>
					<WhatsappShareButton url={url} title={title} separator=":: " aria-label={'Share on Whatsapp'}>
						<WhatsappIcon size={32} round />
					</WhatsappShareButton>
				</div>

				<div className={'flex flex-col'}>
					<RedditShareButton url={url} title={title} windowWidth={660} windowHeight={460} aria-label={'Share on Reddit'}>
						<RedditIcon size={32} round />
					</RedditShareButton>

					<div className={'text-center'}>
						<RedditShareCount url={url} />
					</div>
				</div>

				<div className={'flex flex-col'}>
					<TumblrShareButton url={url} title={title} tags={hashtags} aria-label={'Share on Tumblr'}>
						<TumblrIcon size={32} round />
					</TumblrShareButton>

					<div className={'text-center'}>
						<TumblrShareCount url={url} />
					</div>
				</div>

				<div className={'flex flex-col'}>
					<EmailShareButton url={url} subject={title} body="URL" aria-label={'Share on Email'}>
						<EmailIcon size={32} round />
					</EmailShareButton>
				</div>
			</div>
		</div>
	);
};

export default ShareInSocialNetworks;
